import React, { useState, useContext, useEffect } from 'react';
import { FormItem, Button, FormContext } from '@digital/ui';

import Upload, { UploadProps } from 'antd/lib/upload';
import { isObjEmpty } from '@app/helpers/objHelper';


export default (props: {
  fileName?: string;
  accept?: string;
  hasFile: boolean;
  label?: string;
  url?: string;
  disabled?: boolean;
  idDoComponente: string;
  required?: boolean;
}) => {
  const { fileName, hasFile, accept, label, url, disabled, idDoComponente, required} = props;
  const [file, setFile] = useState();
  const [disabledItem, setDisabledItem] = useState<boolean>(false);
  const buttonLabel = label ? label : 'Adicionar arquivo';

  const { formProps } = useContext(FormContext);
  useEffect(() => {
    setDisabledItem(disabled != undefined && disabled == true ? true : false);
    fileName && setFile([{ uid: '1', name: fileName, url: url }]);
    let remove = !hasFile;
    if (remove) {
      setFile([]);
      formProps && formProps.setFieldValue('formData2', null);
    }
  }, [fileName, hasFile]);

  const uploadProps: UploadProps = {
    action: '',
    multiple: false,
    type: 'select',
    accept: accept ? accept : '.xlsx, .xls, .png, .doc, .docx, .ppt, .pptx,.txt,.pdf',
    onRemove: _ => {
      setFile([]);
      formProps && formProps.setFieldValue('formData2', null);
    },
    beforeUpload: file => {
      setFile([
        {
          uid: '1',
          name: file.name,
        },
      ]);
      formProps && formProps.setFieldValue('formData2', file);
      return false;
    },
    headers: {
      authorization: 'authorization-text',
    },
  };

  return (
    <FormItem name="file" span={12} required={required && isObjEmpty(file) }>
      <Upload
        id={idDoComponente}
        disabled={disabledItem} name="file" {...uploadProps} fileList={file}>
        <Button icon="ui-upload" type='primary'>{buttonLabel}</Button>
      </Upload>
    </FormItem>
  );
};
